export default "__VITE_ASSET__ac151476__"